import { Injectable, InjectionToken, Provider } from '@angular/core';
import { BaseRequestService } from './base-request.service';
import { PaginatedResponse } from '../../shared/pagination/paginated-response';
import { ApiPositionShare } from '../api-types/user.api';
import {
	transformApiPositionSharesToAppPositionShares,
	transformAppPositionShareToApiPositionShare,
} from '../transformers/user.transform';
import { PositionShare } from '../app-types/user.app';

export const POSITION_SHARE_SERVICE = new InjectionToken<PositionShareService>('PositionShareService');

@Injectable()
export class PositionShareService extends BaseRequestService {
	public getAll = async (userId: number, offset?: number, range?: number) => {
		const res = await this.get<PaginatedResponse<ApiPositionShare>>(`positionShares/user/${userId}`, { offset, range });

		const entities = transformApiPositionSharesToAppPositionShares(res.entities);
		const page: PaginatedResponse<PositionShare> = {
			entities: entities,
			offset: res.offset,
			range: res.range,
			totalEntities: res.totalEntities,
		};
		return page;
	};

	public update = async (positionShareId: number, data: PositionShare) => {
		const body = transformAppPositionShareToApiPositionShare(data);
		return await this.put<ApiPositionShare, ApiPositionShare>(`positionShares/${positionShareId}`, body);
	};
}

export const providePositionShareApi: Provider = {
	provide: POSITION_SHARE_SERVICE,
	useClass: PositionShareService,
};
